exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".masraf-report-table[data-v-59c50b76]{width:100%;margin-top:4px}.masraf-report-table>*[data-v-59c50b76]{width:100%}", ""]);

// exports
